export default class SearchableObject {

    getId() {
        throw new Error("method must be overriden by subclasses.");
    }

    getName() {
        throw new Error("method must be overriden by subclasses.");
    }

    getType() {
        throw new Error("method must be overriden by subclasses.");
    }

    isSelectable() {
        throw new Error("method must be overriden by subclasses.");
    }

    isHideable() {
        throw new Error("method must be overriden by subclasses.");
    }

    get visible() {
        throw new Error("method must be overriden by subclasses.");
    }

    /* eslint-disable no-unused-vars */
    set visible(value)  {
        throw new Error("method must be overriden by subclasses.");
    }
    /* eslint-enable no-unused-vars */
    
    getIconUrl() {
        throw new Error("method must be overriden by subclasses.");
    }
}